import type { WebsiteContent } from './types'
import { primaryPhoneNumber } from './constants'

export const contactPanel: WebsiteContent['contactPanel'] = {
  ariaLabel: 'Contact options',
  title: 'What’s nxt?',
  actionOne: {
    title: 'Book a meeting with us',
    buttonLabel: 'Schedule',
    url: 'https://meetings.hubspot.com/nick-scott2/book-time-with-me',
  },
  actionTwo: {
    title: 'Give us a call',
    buttonLabel: primaryPhoneNumber,
    phoneNumber: primaryPhoneNumber,
  },
}
